






















































































































import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["account"]),
    components: {},
})
export default class GsnbStatus extends Vue {
    @Prop({ type: Number })
    id!: number;

    @Prop({ type: String })
    name!: string;

    @Prop({ type: [String, Number] })
    year!: string | number;

    @Prop({ type: Object })
    records!: any;

    @Prop({ type: Number })
    flowType!: number;

    flowName: string = this.flowType === 1 ? "电子税务局" : "自然人扣缴";
    recordsCopy: any = [];

    mounted() {
        this.fetchData()
    }

    cjList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 111,
        },
        {
            text: "未采集",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "采集中",
            id: 3,
        },
        {
            text: "采集完成",
            id: 4,
        },
        {
            text: "采集失败",
            id: 5,
        },
        {
            text: "无需采集",
            id: 6,
        },
    ];
    qsList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        {
            text: "未导入",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "取数完成",
            id: 4,
        },
        {
            text: "取数失败",
            id: 5,
        },
    ];
    sbList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        {
            text: "未申报",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "申报中",
            id: 3,
        },
        {
            text: "申报通过",
            id: 4,
        },
        {
            text: "申报异常",
            id: 5,
        },
    ];
    list: any = []
    async fetchData() {
        const res = Vue.axios
            .get(
                `gsnb/record/detail?accountBookId=${this.id
                }&year=${this.year}`
            )
            .then((res) => {
                // this.clientList = res.data.data.content;
                // this.totalElements = res.data.data.totalElements;
                this.list = res.data.data
                this.$forceUpdate();
            });
    }
    getStatus(type: number, code: number) {
        if (type === 0) {
            if (code) {
                for (let i = 0; i < this.cjList.length; i++) {
                    if (this.cjList[i].id === code) return this.cjList[i].text;
                }
            } else return ""

        }
        else if (type === 1) {
            for (let i = 0; i < this.qsList.length; i++) {
                if (this.qsList[i].id === code) return this.qsList[i].text;
            }
        }
        else if (type === 2) {
            for (let i = 0; i < this.sbList.length; i++) {
                if (this.sbList[i].id === code) return this.sbList[i].text;
            }
        }
    }
    downLoad(data: any) {
        if (data.resultUrl) {
            let url = data.resultUrl;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
        }
    }
    // 查看详情
    errContent(msg: string) {
        if (msg) {
            this.$message.warning(msg);
        }
    }
    delRow(data: any) {
        Vue.axios.post(`gsnb/record/delete`, { id: data.id }).then((res) => {
            this.fetchData();
        });
    }
    change(data: any) {
        Vue.axios.post(`gsnb/record/retry`, { id: data.id }).then((res) => {
            this.fetchData();
        });
    }
    // 查看图片
    showImg: boolean = false;
    imgSrc: string = "";
    imgList: string[] = [];
    changeImg(img: string) {
        this.imgSrc = img;
        this.imgList = [img];
        this.showImg = true;
    }
    imgWidth: number = 100;
    imgHeight: number = 100;
    plus() {
        if (this.imgWidth < 160) {
            this.imgWidth = this.imgWidth + 10;
        }
        if (this.imgHeight < 160) {
            this.imgHeight = this.imgHeight + 10;
        }
    }
    cut() {
        if (this.imgWidth > 100) {
            this.imgWidth = this.imgWidth - 10;
        }
        if (this.imgHeight > 100) {
            this.imgHeight = this.imgHeight - 10;
        }
    }
    reSet() {
        this.imgHeight = 100;
        this.imgWidth = 100;
    }
}
